// mds-dojo — dijit/_OnDijitClickMixin — FAITHFUL port of references/dijit/_OnDijitClickMixin.js.
// Deprecated back-compat mixin: makes this.connect(node, "ondijitclick", ...) route to
// the dijit/a11yclick event. declare from the faithful runtime.
// Unused on/array/keys/has imports dropped.
import declare from '../dojo/_base/declare-runtime'; // declare
import a11yclick from './a11yclick';

var ret: any = declare('dijit._OnDijitClickMixin', null, {
  // summary:
  //		Deprecated.   New code should access the dijit/a11yclick event directly.
  //		Mixing in this class will make _WidgetBase.connect(node, "ondijitclick", ...) work.

  connect: function (obj: any, event: any, method: any) {
    // override _WidgetBase.connect() to make this.connect(node, "ondijitclick", ...) work
    return this.inherited(arguments, [obj, event == 'ondijitclick' ? a11yclick : event, method]);
  },
});

ret.a11yclick = a11yclick;	// back compat

export default ret;
